
var product_on_page = $('.products-on-page');
var next_url = product_on_page.data('next-url');
var loadmore_button = $('.load-more-button-btn');
var loading_spinner = $('.loading-spinner');
var TARGET_VISIBLE_PRODUCTS = 32;
var currentVisibleLimit = TARGET_VISIBLE_PRODUCTS;

/**
 * Re-initialize load more variables after AJAX updates (e.g., filter changes)
 * This must be called whenever the product grid is replaced via AJAX
 */
function reinitLoadMore() {
    product_on_page = $('.products-on-page');
    next_url = product_on_page.data('next-url');
    loadmore_button = $('.load-more-button-btn');
    loading_spinner = $('.loading-spinner');
    currentVisibleLimit = TARGET_VISIBLE_PRODUCTS;
    
    // Apply initial product limit after reinit, then check button visibility
    setTimeout(function() {
        limitVisibleProducts(TARGET_VISIBLE_PRODUCTS);
        showLoadMoreButtonIfNeeded();
    }, 100);
}

// Expose reinit function globally for facets.js to call
window.reinitLoadMore = reinitLoadMore;

function limitVisibleProducts(limit) {
    let allProducts = product_on_page.find('.grid__item');
    let visibleProducts = allProducts.filter(':visible').not('.hidden-overflow');
    
    if (visibleProducts.length > limit) {
        visibleProducts.slice(limit).addClass('hidden-overflow').hide();
        showLoadMoreButtonIfNeeded();
    }
}

/**
 * Show the load more button if there are hidden products (either from JS limit or more pages)
 */
function showLoadMoreButtonIfNeeded() {
    let hiddenProducts = product_on_page.find('.grid__item.hidden-overflow');
    
    // Check if we have a corrected total count from search-filter-correction.js (for search pages)
    // This handles the case where Shopify says "Page 1 of 3" (so next_url exists)
    // but all subsequent products are hidden by business rules (e.g. Swatches).
    if (typeof window.searchFilterCorrectionTotalVisible !== 'undefined') {
        const visibleNow = countCurrentlyVisible();
        
        // If we still have hidden-overflow items on the current page, show button to reveal them
        if (hiddenProducts.length > 0) {
            loadmore_button.show();
            $('.load-more-button').show();
            return;
        }
        
        // If visible products >= corrected total, we have shown everything possible -> Hide button
        if (visibleNow >= window.searchFilterCorrectionTotalVisible) {
            loadmore_button.hide();
            $('.load-more-button').hide();
            return;
        }
    }
    
    // Default logic: Show button if there are hidden products OR if there's a next page
    if (hiddenProducts.length > 0 || next_url) {
        loadmore_button.show();
        $('.load-more-button').show();
    } else {
        loadmore_button.hide();
        $('.load-more-button').hide();
    }
}

// Listen for updates from search-filter-correction.js
window.addEventListener('search:filter-counts-updated', function(e) {
    if (e.detail && typeof e.detail.count !== 'undefined') {
        window.searchFilterCorrectionTotalVisible = e.detail.count;
        showLoadMoreButtonIfNeeded();
    }
});

/**
 * Count the currently visible (non-hidden-overflow, non-display-none) products
 */
function countCurrentlyVisible() {
    return product_on_page.find('.grid__item:visible').not('.hidden-overflow').length;
}

/**
 * Fetch the next page of products via AJAX and append them to the grid.
 * Returns a Promise that resolves when done.
 */
function fetchNextPage() {
    return new Promise(function(resolve, reject) {
        if (!next_url) {
            resolve(0);
            return;
        }
        
        $.ajax({
            url: next_url,
            type: 'GET',
            dataType: 'html',
            success: function(data) {
                var new_products = $(data).find('.products-on-page').html();
                next_url = $(data).find('.products-on-page').data('next-url');
                
                product_on_page.append(new_products);
                
                // Re-init product card sliders for newly appended items
                try {
                    if (typeof window.initCardProductSliders === 'function') {
                        window.initCardProductSliders();    
                    }
                    if (typeof yotpoWidgetsContainer !== 'undefined' && yotpoWidgetsContainer.initWidgets) {
                        yotpoWidgetsContainer.initWidgets();
                    }
                } catch (e) {
                    console.warn('initCardProductSliders failed', e);
                }
                
                resolve(1);
            },
            error: function(xhr, status, error) {
                console.error('Load more fetch error:', error);
                reject(error);
            }
        });
    });
}

/**
 * Keep fetching pages until we have enough visible products to meet the target,
 * or until there are no more pages to fetch.
 */
function fillToTarget(target, callback) {
    var visibleNow = countCurrentlyVisible();
    
    // Already have enough, or no more pages — done
    if (visibleNow >= target || !next_url) {
        callback();
        return;
    }
    
    // Fetch another page and check again
    fetchNextPage().then(function() {
        // Small delay for DOM to settle
        setTimeout(function() {
            fillToTarget(target, callback);
        }, 50);
    }).catch(function() {
        callback();
    });
}

/**
 * Main load more function — fill-to-target strategy.
 * 
 * Always adds exactly TARGET_VISIBLE_PRODUCTS (32) new visible products:
 *   1. Reveal all hidden-overflow products
 *   2. If visible count < target, keep fetching pages until target is met
 *   3. Hide excess beyond target as hidden-overflow
 *   4. Last batch: show whatever remains
 */
function loadMore() {
    loading_spinner.show();
    loadmore_button.hide();
    
    // Snapshot the current visible count — target is current + 32
    var visibleBefore = countCurrentlyVisible();
    var target = visibleBefore + TARGET_VISIBLE_PRODUCTS;
    
    // Step 1: Reveal ALL hidden-overflow products immediately
    var hiddenProducts = product_on_page.find('.grid__item.hidden-overflow');
    if (hiddenProducts.length > 0) {
        hiddenProducts.removeClass('hidden-overflow').show();
    }
    
    // Step 2: Fill to target — fetch as many pages as needed
    fillToTarget(target, function() {
        // Step 3: Now we either have enough or ran out of pages
        var visibleNow = countCurrentlyVisible();
        
        if (visibleNow > target) {
            // Hide excess beyond target as hidden-overflow
            var allProducts = product_on_page.find('.grid__item');
            var visibleProducts = allProducts.filter(':visible').not('.hidden-overflow');
            if (visibleProducts.length > target) {
                visibleProducts.slice(target).addClass('hidden-overflow').hide();
            }
        }
        
        currentVisibleLimit = Math.min(target, visibleNow);
        loading_spinner.hide();
        showLoadMoreButtonIfNeeded();
    });
}

// Apply limit on initial page load
$(document).ready(function() {
    setTimeout(function() {
        limitVisibleProducts(TARGET_VISIBLE_PRODUCTS);
        showLoadMoreButtonIfNeeded();
    }, 200);
});
